module.exports = __webpack_public_path__ + "static/media/arequipa.ccbab63d.jpg";